module.exports = __webpack_public_path__ + "static/jegede-cecc12b95d547cd97d4ad963dfbd81c0.png";